import "./_index.scss";

const LoadingImage = ({className = ""}) => {
  return (
    <img className={`loading-image ${className ? className : ""}`} src={require("assets/loading3.svg").default} alt="Loading..." />
  );
};

export default LoadingImage;
